import { jsx as _jsx } from "react/jsx-runtime";
const AmbientBackground = () => {
    return (_jsx("div", { "aria-hidden": "true", className: "ambient-background fixed inset-0 z-0 pointer-events-none" }));
};
export default AmbientBackground;
